import { createAction } from '@ngrx/store';

const loadOffers = createAction('[HqOffer Picker Modal Component] Load offers');

export const HqOfferPickerModalActions = {
  loadOffers,
};
